import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/Hero';
import { IntroText } from '../components/IntroText';
import { VisualBreak1 } from '../components/VisualBreak1';
import { Technology } from '../components/Technology';
import { DualLaser } from '../components/DualLaser';
import { VisualBreak2 } from '../components/VisualBreak2';
import { Environment } from '../components/Environment';
import { Service } from '../components/Service';
import { QuoteBreak } from '../components/QuoteBreak';
import { VisualBreak3 } from '../components/VisualBreak3';
import { WhyUs } from '../components/WhyUs';
import { CTA } from '../components/CTA';
import { NextPageLink } from '../components/NextPageLink';
import { useSEO } from '../utils/seo';
export const Home = () => {
  useSEO({
    title: 'Détatouage à Martigny | Laser Picoseconde & Q-Switched | Dispel Your Tattoo Valais',
    description: 'Détatouage professionnel à Martigny, Valais. Spécialiste du laser picoseconde et Q-Switched pour enlever ou éclaircir votre tatouage en toute sécurité. Consultations transparentes et résultats maîtrisés au cœur du Valais.',
    canonical: 'https://www.dispelyourtattoo.ch'
  });
  return <main data-id="element-907">
      <Hero data-id="element-908" />
      <IntroText data-id="element-909" />
      <VisualBreak1 data-id="element-910" />
      <Technology data-id="element-911" />
      <DualLaser data-id="element-912" />
      <VisualBreak2 data-id="element-913" />
      <Environment data-id="element-914" />
      <Service data-id="element-915" />
      <VisualBreak3 data-id="element-916" />
      <WhyUs data-id="element-917" />
      <CTA data-id="element-918" />
      <NextPageLink data-id="element-919" />
    </main>;
};